import { render, staticRenderFns } from "./EventTheme.vue?vue&type=template&id=199be0c7&scoped=true"
import script from "./EventTheme.vue?vue&type=script&lang=ts"
export * from "./EventTheme.vue?vue&type=script&lang=ts"
import style0 from "./EventTheme.vue?vue&type=style&index=0&id=199be0c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199be0c7",
  null
  
)

export default component.exports